import React, { useEffect, useState } from "react";
import Logs from "./Logs";
import { Formik, Form, Field } from "formik";
import { Input, ReactSelector } from "../../../../_metronic/_partials/controls";
import { i18n } from "../../private/languageSelector";
import * as Yup from "yup";
import PinInput from "react-pin-input";
import pasteIcon from "../../../../assets/img/company/copyIcon.svg";
import backIcon from "../../../../assets/img/company/navigateBackIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as actions from "../../../../_redux/pos/posActions";
import * as zatcaActions from "../../../../_redux/zatca/zatcaActions";
import { storesSlice } from "../../../../_redux/stores/storeSlice";
import CertificateDetails from "./CertificateDetails";
import SubscriptionDialog from "../../company/company-edit-Dialog/SubscriptionDialog";
import toast from "react-hot-toast";
function ZatcaPosDetails() {
  const [otpValue, setOtpValue] = useState("");
  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);
  const [showCertificateDetails, setShowCertificateDetails] = useState(false);
  const [type, setType] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [logsLoading, setLogsLoading] = useState(false);
  const id = window?.location?.pathname?.split("/").pop();
  const { posForEdit, companyForEdit, totalCount, allLogsCount, allZatcaLogs, user } = useSelector((state) => ({
    posForEdit: state.pos.posForEdit,
    totalCount: state.zatca.totalLogsCount,
    companyForEdit: state.company.companyForEdit,
    allLogsCount: state.zatca.allLogsCount,
    allZatcaLogs: state.zatca.zatcaLogs,
    user: state?.auth?.user,
  }));

  let backOfficeAccess = user?.rolePayload?.backOfficePayload;

  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    if (id) {
      dispatch(actions.fetchPos(id));
    }
    //eslint-disable-next-line
  }, [id, showCertificateDetails]);

  useEffect(() => {
    if (posForEdit?.zatca?.certificateId?.length > 0 && posForEdit?.zatca?.onboardedAt?.length > 0) {
      setShowCertificateDetails(true);
    } else {
      setShowCertificateDetails(false);
    }
  }, [posForEdit, id]);

  let envInitOptions = { environmentType: { label: "Select...", value: "select" } };
  let envSchema = Yup.object().shape({
    environmentType: Yup.string(),
  });

  const language = localStorage.getItem("language");
  let posData = {
    name: posForEdit?.name,
    model: "Fatoraty System v1.0",
    storeName: posForEdit?.store?.name,
    storeAddress: posForEdit?.store?.address,
    id: posForEdit?.businessId,
    taxIdNo: posForEdit?.store?.taxNumber,
    crNo: posForEdit?.store?.commercialRegistery,
  };
  // value is what the backend receives as `environment`; label is display text only (it is translated)
  let typeOptions = [
    { label: "Sandbox", value: "sandbox", disabled: false },
    { label: i18n("Integration.Simulation"), value: "simulation", disabled: false },
    { label: i18n("Integration.Production"), value: "production", disabled: true },
  ];

  const handlePin = (value) => {
    setOtpValue(value);
  };

  const handlePaste = async () => {
    try {
      let text = await navigator.clipboard.readText();
      text = text.replace(/\D/g, "").slice(0, 6); // only numbers, max 6
      console.log("Pasted OTP:", text);
      setOtpValue(text);
    } catch (err) {
      console.error("Clipboard access denied", err);
    }
  };
  const handleBack = () => {
    if (otpValue?.length > 0) {
      setShowUnsavedChangesModal(true);
    } else {
      dispatch(storesSlice.actions.showLayout(true));
      history.push("/zatca");
    }
  };
  const handleLinkPosToZatca = (setFieldValue) => {
    toast.loading("Link request submitted to ZATCA. Pending Response.", { duration: 1000 });
    if (!posForEdit?.store?.address || posForEdit?.store?.address?.length === 0) {
      return toast.error("Please configure Store Address first");
    }
    // if (otpValue !== "123345" && type === "Simulation") {
    if (otpValue !== "123345" && type === "sandbox") {
      return toast.error("Invalid otp");
    } else {
      dispatch(zatcaActions.OnboardPosToZatca(posForEdit?._id, otpValue, type, setShowCertificateDetails)).then(() => {
        setOtpValue("");
        setLogsLoading(true);
      });
    }
  };

  useEffect(() => {
    if (companyForEdit?._id && id) {
      let searchData = {
        searchName: searchValue,
        limit: 10,
        actionId: id,
      };
      dispatch(zatcaActions.getAllZatcaOnboardingLogs(companyForEdit?._id, searchData)).then(() => {
        setLogsLoading(false);
      });
    }
  }, [dispatch, searchValue, id, companyForEdit, logsLoading]);

  const loadMoreZatcaLogs = () => {
    if (companyForEdit?._id && id) {
      let searchData = {
        searchName: searchValue,
        limit: +totalCount + 10,
        actionId: id,
      };
      dispatch(zatcaActions.getAllZatcaOnboardingLogs(companyForEdit?._id, searchData));
    }
  };
  // const expireCertificateInTwoMinutes = () => {
  //     if (posForEdit?._id) {
  //       dispatch(zatcaActions.expireCertificateInTwoMinutes(posForEdit?._id));
  //     }
  //   };

  const zatcaManagemntAccess = backOfficeAccess[9]?.selected && backOfficeAccess[9]?.subItem[0]?.selected;

  return (
    <div className="zatca-wrapper">
      <div
        className={`store-sub-header ${language === "arabic" ? "arabic-lang rtl" : "ltr"}`}
        style={{ marginLeft: language === "english" && "-7.3rem", marginTop: "-6rem" }}
      >
        <div
          className={`date-header ${language === "arabic" ? "store-invoice-header" : "store-invoice-header-english"}  w-100  justify-content-start`}
          style={{ background: "#2D9CDB" }}
        >
          <div onClick={handleBack} className="cursor-pointer">
            <img src={backIcon} alt="back" className={`${language === "arabic" ? "rotate-180" : "rotate-360"}`} />
          </div>
          <div className="heading-text" style={{ marginLeft: language === "english" && "6rem", marginRight: "6rem" }}>
            {i18n("Integration.ZatcaIntegration")}
          </div>
          {/* {!posForEdit?.zatca?.isExpired ? (
            <div style={{ color: "#FF5F57", cursor: "pointer" }} onClick={expireCertificateInTwoMinutes}>
              Expire in 2 Mins
            </div>
          ) : null}{" "} */}
        </div>
      </div>
      <div className={`row ${language === "arabic" ? "rtl" : "ltr"}`} style={{ paddingTop: "5rem" }}>
        <div className="col">
          <div>
            <Formik enableReinitialize={true} initialValues={posData}>
              {({ handleSubmit, values }) => {
                return (
                  <>
                    <Form className={`form form-label-right ${language === "arabic" ? "rtl" : "ltr"}`}>
                      <div className="w-100 p-5 border-radius-4" style={{ background: "#FFFFFF" }}>
                        {/* form data */}
                        <div className="pos-details-text py-4 pb-5">{i18n("Integration.POSDetails")}</div>
                        <div className="form-group mt-5">
                          <Field
                            name="name"
                            label={i18n("Integration.DeviceName")}
                            component={Input}
                            placeholder={i18n("Integration.DeviceName")}
                            withFeedbackLabel={true}
                            readOnly={true}
                            disabled={true}
                          />
                        </div>
                        <div className="form-group mt-5">
                          <Field
                            name="id"
                            component={Input}
                            placeholder={i18n("Integration.DeviceId")}
                            label={i18n("Integration.DeviceId")}
                            readOnly={true}
                            disabled={true}
                          />
                        </div>
                        <div className="form-group mt-5">
                          <Field
                            name="model"
                            component={Input}
                            placeholder={i18n("Integration.Model")}
                            label={i18n("Integration.Model")}
                            readOnly={true}
                            disabled={true}
                          />
                        </div>
                        <div className="form-group mt-5">
                          <Field
                            name="storeName"
                            component={Input}
                            placeholder={i18n("Integration.StoreName")}
                            label={i18n("Integration.StoreName")}
                            readOnly={true}
                            disabled={true}
                          />
                        </div>
                        <div className="form-group mt-5">
                          <Field
                            name="storeAddress"
                            component={Input}
                            placeholder={i18n("global.StoreAddress")}
                            label={i18n("global.StoreAddress")}
                            readOnly={true}
                            disabled={true}
                          />
                        </div>
                        <div className="form-group mt-5">
                          <Field
                            name="taxIdNo"
                            component={Input}
                            placeholder={i18n("Integration.TaxIdNo")}
                            label={i18n("Integration.TaxIdNo")}
                            readOnly={true}
                            disabled={true}
                          />
                        </div>
                        <div className="form-group mt-5">
                          <Field
                            name="crNo"
                            component={Input}
                            placeholder={i18n("Integration.CrNo")}
                            label={i18n("Integration.CrNo")}
                            readOnly={true}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </Form>
                  </>
                );
              }}
            </Formik>
          </div>
        </div>
        <div className="col-4">
          {!showCertificateDetails ? (
            <div className="bg-white p-5 border-radius-4 w-100">
              <div>
                <Formik enableReinitialize={true} validationSchema={envSchema} initialValues={envInitOptions}>
                  {({ handleSubmit, values, setFieldValue, setErrors, errors }) => {
                    if (errors?.environmentType?.length > 0) {
                      setErrors({ environmentType: "" });
                    }
                    return (
                      <>
                        <div className={`d-flex justify-content-between align-items-center `}>
                          <div className="zatca-text py-4 pb-5">{i18n("Integration.IntegrationWithZatca")}</div>
                          <div
                            className={`link-text ${
                              zatcaManagemntAccess && otpValue?.length === 6 ? "active" : "inactive"
                              // otpValue?.length === 6 ? "active" : "inactive"
                            }`}
                            onClick={() => handleLinkPosToZatca(setFieldValue)}
                          >
                            {i18n("Integration.Link")}
                          </div>
                        </div>
                        <div className="muted-desc-text py-5">{i18n("Integration.SelectType")}</div>
                        <Form className={`form custom-label form-label-right ${language === "arabic" ? "rtl" : "ltr"}`}>
                          <Field
                            name="type"
                            placeholder={i18n("Integration.Select")}
                            label={i18n("Integration.Type")}
                            component={ReactSelector}
                            isOptionDisabled={(option) => option.disabled}
                            options={typeOptions}
                            onChange={(option) => {
                              setFieldValue("environmentType", option);
                              // the environment value, not the (translated) label - "محاكاة" is not an environment
                              setType(option?.value);
                            }}
                            withFeedbackLabel={true}
                            styles={{
                              control: (base) => ({
                                ...base,
                                border: "none",
                                borderBottom: "2px solid #E0E0E0",
                                boxShadow: "none",
                                minHeight: "38px",
                                borderRadius: "0px",
                              }),
                              indicatorSeparator: () => ({ display: "none" }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                display: "none",
                              }),
                            }}
                          />
                          {values?.environmentType?.label !== "Select..." ? (
                            <div style={{ marginTop: "3rem" }}>
                              <div className="pin-code-text">
                                {language === "arabic" ? (
                                  <> أدخل رمز التحقق الذي استلمته من بوابة فاتورة، أو قم بزيارة موقع هيئة الزكاة للحصول على الرمز.</>
                                ) : (
                                  <>
                                    Enter the verification code you received from the Fatoora portal, or Visit the{" "}
                                    <a className="main-text" target="_blank" href="https://login.zatca.gov.sa/" rel="noopener noreferrer">
                                      Zakat
                                    </a>{" "}
                                    website to get the code.
                                  </>
                                )}
                              </div>
                              <div className="mt-5 py-4">
                                <div className="d-flex align-items-center" style={{ gap: ".5rem" }}>
                                  <div className="paste-box p-4 whitespace-nowrap" onClick={handlePaste}>
                                    <img src={pasteIcon} alt="paste-icon" />
                                    <span className="mx-3">{i18n("Integration.Paste")}</span>
                                  </div>
                                  <div className="form-group ltr mb-0">
                                    <PinInput
                                      length={6}
                                      initialValue={otpValue}
                                      key={otpValue}
                                      secret={false}
                                      focus={false}
                                      type="numeric"
                                      style={{ width: "100%" }}
                                      inputStyle={{
                                        width: "35px",
                                        height: "35px",
                                        marginLeft: "1rem",
                                        marginRight: "1rem",
                                        borderRadius: "5px",
                                        border: "1px solid #B3B3B3",
                                        fontSize: "14px",
                                        background: "transparent",
                                        color: "#000000",
                                        direction: "ltr",
                                        marginTop: ".5rem",
                                        marginBottom: ".5rem",
                                      }}
                                      onChange={handlePin}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </Form>
                      </>
                    );
                  }}
                </Formik>
              </div>
            </div>
          ) : (
            <div className="bg-white p-5 border-radius-4 w-100">
              <CertificateDetails posForEdit={posForEdit} setLogsLoading={setLogsLoading} />
            </div>
          )}
        </div>
        <div className="col-3">
          <Logs
            isDownloadable={true}
            allLogs={allZatcaLogs}
            totalCount={totalCount}
            allLogsCount={allLogsCount}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            loadMoreZatcaLogs={loadMoreZatcaLogs}
          />
        </div>
      </div>
      <SubscriptionDialog
        modalWidth={"350px"}
        modalHeight={"185px"}
        modalBackgroundColor={"#FFFFFF"}
        show={showUnsavedChangesModal}
        onHide={() => setShowUnsavedChangesModal(false)}
        title={i18n("SubscriptionModals.UnsavedChanges")}
        titleWidth={"140px"}
        titleHeight={"20px"}
        titleFontWeight={"700"}
        titleFontSize={"16px"}
        titleLineHeight={"20px"}
        titleColor={"#333333"}
        message={i18n("SubscriptionModals.AreYouSureYouWantToContinueWithoutSavingChanges")}
        messageWidth={"320px"}
        messageHeight={"44px"}
        messageFontSize={"16px"}
        messageFontWeight={"400"}
        messageLineHeight={"21.79px"}
        messageColor={"#333333"}
        primaryLabel={i18n("SubscriptionModals.CANCEL")}
        primaryAction={() => setShowUnsavedChangesModal(false)}
        primaryLabelWidth={"55px"}
        primaryLabelHeight={"20px"}
        primaryLabelFontWeight={"700"}
        primaryLabelFontSize={"14px"}
        primaryLabelLineHeight={"20px"}
        primaryLabelColor={"#828282"}
        secondaryAction={() => {
          setShowUnsavedChangesModal(false);
          dispatch(storesSlice.actions.showLayout(true));
          history.push("/zatca");
        }}
        secondaryLabel={i18n("SubscriptionModals.CONTINUE")}
        secondaryLabelWidth={"75px"}
        secondaryLabelHeight={"20px"}
        secondaryLabelFontWeight={"700"}
        secondaryLabelFontSize={"14px"}
        secondaryLabelLineHeight={"20px"}
        secondaryLabelColor={"#2D9CDB"}
        isCenteredOnMobile
      />
    </div>
  );
}

export default ZatcaPosDetails;
